<!-- eslint-disable -->
<template lang="pug">
    .cs-select
        svg-icon.cs-select__icon(
            name="angle",
            :class=`{
                'cs-select__icon--error': error,
            }`
        )
        select.cs-select__body(
            :value="value",
            @input="selectHandler",
            :placeholder="placeholder",
            :required="required",
            :disabled="disabled",
            :class=`{
                'cs-select__body--error': error,
                'cs-select__body--disabled': disabled,
            }`
        )
            option.cs-select__option(
                v-for="option in resultOptions",
                :value="trackBy ? option[trackBy] : option",
                v-text="trackBy && label ? option[label] : option"
            )
</template>

<script>
    /*eslint-disable*/
    import SvgIcon from "./SvgIcon.vue"

    /**
     * CsSelects are used to allow users to choose any item from options list.
     */
    export default {
        name: "CsSelect",
        status: "ready",
        release: "1.0.0",
        props: {
            /**
             * Selected item.
             */
            value: {
                type: [String, Number],
                default: null,
            },
            /**
             * The placeholder value for the form select field.
             */
            placeholder: {
                type: String,
                default: null,
            },
            /**
             * The error state of select field.
             */
            error: {
                type: Boolean,
                default: false,
            },
            /**
             * The array of selectable options.
             */
            options: {
                type: [Array, Number],
                default: [],
            },
            /**
             * First number of result options array when options is a number.
             */
            firstNumber: {
                type: Number,
                default: 1,
            },
            /**
             * If true, disable select on screen.
             */
            disabled: {
                type: Boolean,
                default: false,
            },
            /**
             * Sets html required attribute on select.
             */
            required: {
                type: Boolean,
                default: false,
            },
            /**
             * Key to compare objects.
             */
            trackBy: {
                type: String,
                default: null,
            },
            /**
             * Label to show in options.
             */
            label: {
                type: String,
                default: null,
            },
        },
        computed: {
            resultOptions() {
                if (typeof this.options === "number" && this.firstNumber > 1) {
                    let array = []
                    for (let i = this.firstNumber; i <= this.options; i++) {
                        array.push(i)
                    }
                    return array
                }
                return this.options
            },
        },
        methods: {
            selectHandler(event) {
                this.$emit("input", event.target.value)
            },
        },
        components: {
            SvgIcon,
        },
  }
</script>

<style lang="scss" scoped>
    .cs-select {
        position: relative;
        cursor: pointer;

		    margin-bottom: $space-x-small;
		    &:last-child {
				    margin-bottom: 0;
		    }
		}

    .cs-select__icon {
      color: $hsl-color-blue-56;
      position: absolute;
      // vertical center(size of icon - 1em)
      top: 50%;
      margin-top: -0.5em;
      right: $space-small;
      pointer-events: none;
    }

    .cs-select__icon--error {
        color: $hsl-color-red-62;
    }

    .cs-select__body {
		    box-sizing: border-box;

		    appearance: none;
		    outline: none;

		    color: $x-color-black;

		    width: 100%;

		    padding: 0.5em 0.625em;

		    border-radius: $border-radius-6;
		    border: 1px solid $hsl-color-gray-74;

		    font-weight: normal;
		    font-size: $font-size-16;
		    line-height: $font-size-19;

		    cursor: pointer;
        background-color: $x-color-white;


		    &:hover {
				    border-color: $hsl-color-blue-56;
		    }

		    &:focus {
				    border-color: $hsl-color-blue-56;
		    }

		    &:active {
				    border-color: $hsl-color-gray-74;
				    border-bottom-left-radius: 0;
				    border-bottom-right-radius: 0;
		    }

		    &::placeholder {
				    font-weight: lighter;
		    }
    }

    .cs-select__body--error {
		    border-color: $hsl-color-red-62;
		    color:  $hsl-color-red-62;

		    &:hover {
				    border-color:  $hsl-color-red-62;
		    }

		    &:focus {
				    border-color: $hsl-color-red-62;
		    }

		    &:active {
				    border-color:  $hsl-color-red-62;
		    }
    }

    .cs-select__body--disabled {
		    cursor: not-allowed;
		    pointer-events: none;
		    background-color: $hsl-color-gray-74;
		    color: $hsl-color-gray-74;
    }
</style>
